// utils/logout.js
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  // Clear cookies (optional)
  document.cookie = "post_login_verify_payload=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  document.cookie = "post_login_quick_summary_path=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

  // Clear dashboard undo history — must not carry over to next login session
  sessionStorage.removeItem('server_monitoring_undo_v1');

  // Signal dashboard components to clear undo history before page redirects
  window.dispatchEvent(new CustomEvent('app:logout'));

  // Redirect to login
  window.location.href = '/'; 
};
